import React, { Suspense } from "react";

import { Route, Redirect, Switch, useRouteMatch } from "react-router-dom";

import { Loader } from "shared/components/Loader";

import { routes, RouteUrls } from "./routing.constants";

export const Roulette: React.FC = React.memo(() => {
  const isPrerenderedRoute = useRouteMatch({
    path: [RouteUrls.ROOT_URL, RouteUrls.FOR_INFLUENCERS_URL, RouteUrls.WAX_WALLET_URL],
    exact: true,
  });
  const content = (
      <Switch>
        {routes.map((routeProps, index) => {
          return <Route {...routeProps} key={index} />;
        })}
        <Redirect to={RouteUrls.BUY_NFT_URL} />
      </Switch>
  );

  return isPrerenderedRoute ? content : (
    <Suspense fallback={<Loader isLoading={true} />}>{content}</Suspense>
  );
});
